module.exports = __webpack_public_path__ + "img/Plain.4ddb9e5c.svg";